import { FunctionComponent } from "react";
import { useNavigate } from "react-router";
import { useMsal } from "@azure/msal-react";

import { ErrorPageWithActionsPage } from "..";
import { fallbackTranslationKeys } from "../../../models/app-fallback-translation-keys";
import { RouteConstants } from "../../../models/enums";

export const NoAIFeaturePermissionsPage: FunctionComponent = () => {
  const { instance: pca } = useMsal();
  const navigate = useNavigate();

  return (
    <ErrorPageWithActionsPage
      pca={pca}
      titleKey={fallbackTranslationKeys.noPermissioToUseAppTranslations.title}
      descriptionKey={fallbackTranslationKeys.noPermissioToUseAppTranslations.description}
      redirectAction={() => navigate(`/${RouteConstants.LandingPage}`, { replace: true })}
    />
  );
};
